import store from '@/store'
import stepperModule from '@/store/stepper.module'
import { realEstatesService } from '@/services/realEstates.service'
import { HZ_INVESTOR_ONBOARDING_PATHNAME } from '@/router/constants'

export const investorBeforeEnter = async () => {
  if (!store.hasModule('stepper')) {
    store.registerModule('stepper', stepperModule)
  }

  // Agence (abonné Horiz Pro) : jamais l'onboarding propriétaire, l'écran s'affiche même sans bien.
  if (store.getters['auth/isPro']) {
    return true
  }

  const count = await realEstatesService.getRealEstateNumber()

  if (count.count > 0) {
    return true
  } else {
    return HZ_INVESTOR_ONBOARDING_PATHNAME
  }
}
